import { z } from 'zod';

import { BankruptcyId } from '../BrandedIds';
import { Bankruptcy, BankruptcyFiledBy } from '../loan/Bankruptcy';
import { StopSettings } from '../loan/StopSettings';
import { BaseLoanEvent } from './BaseLoanEvent';

const BankruptcyEventFields = Bankruptcy.pick({
  chapter: true,
  filedAt: true,
  caseNumber: true,
  status: true,
  endOutcome: true,
  endDate: true,
}).extend({
  bankruptcyId: BankruptcyId.optional(),
  filedBy: BankruptcyFiledBy.array().min(1).optional(),
});

/**
 * Reuses the pre-existing `'updateBankruptcy'` type string so historical events
 * replay through the new handler. Old events stored in the DB with a nested
 * `bankruptcy: {...}` field must be rewritten to this flat shape by the
 * backfill migration script.
 */
export const UpsertBankruptcyEvent = BaseLoanEvent.extend({
  type: z.literal('updateBankruptcy'),
  ...BankruptcyEventFields.shape,
  stopSettings: StopSettings.optional(),
  previousStopSettings: StopSettings.optional(),
  comment: z.string().optional(),
});
export type UpsertBankruptcyEvent = z.infer<typeof UpsertBankruptcyEvent>;
